module.exports = __webpack_public_path__ + "img/boxnav.e517c76f.png";